import React, { useState } from "react";
import { Accordion } from "oolib";
import { StyledStageContent, StyledDividerLarge } from "../styled";
import { DescriptionText } from "./DescriptionText";
import { JsonPreview } from "./JsonPreview";

export const StageAccordion = ({ stage }) => {
  const [open, setOpen] = useState(Boolean(stage.defaultOpen));

  return (
    <Accordion
      id={`stage-${stage.id}`}
      title={stage.title}
      expand={open}
      setExpand={setOpen}
      HeaderStyle="HeaderStyle3"
    >
      <StyledStageContent>
        {stage.description ? (
          <>
            <DescriptionText>{stage.description}</DescriptionText>
            <StyledDividerLarge />
          </>
        ) : null}
        <JsonPreview data={stage.data} collapseDepth={1} emptyFallback="No data for this stage." />
      </StyledStageContent>
    </Accordion>
  );
};


